<div style="display: flex;flex-direction: column;align-items: center;
justify-content: center;flex:1;align-self: center;">
 


    <mat-card style="margin-top: 25px;margin-left: 2%;margin-right: 2%;">
      <!-- <div style="justify-content: center;align-self: center;margin-top: 2%;"> -->
        <span style="font-size: 25px;">{{'Search Document in Library' | translate | async}}</span>  
        <span class="material-icons" style="margin-left: 90%; font-size: 27px; cursor: pointer;" title="Add New Document" (click)="NavigateToDocumentLibraryComponent()">articlearrow_right_althome</span>
      <!-- </div> -->
      <div class="search-options"
        style="min-width: 150px;width: 100%;display: flex;justify-content: space-between;flex-wrap: wrap;height: 400px;">

      


        <!-- <mat-form-field class="header-form-full-width">
          <mat-select 
            placeholder="Select Build #" [(ngModel)]="Selectmodel">
            <mat-option [value]="model.ID" *ngFor="let model of modelList">{{model.modelName}}</mat-option> 
          </mat-select>
        </mat-form-field> -->

        <!-- <mat-form-field  class="header-form-full-width">
          <input type="text"  placeholder="Select Build #"  (input)="changeModelAutoComplete($event)"   matInput  [matAutocomplete]="auto" name="fieldName" ngDefaultControl>
          <mat-autocomplete (optionSelected)="onSelectBuildNO($event.option.value)"  [(ngModel)]="Selectmodel" #model_auto="ngModel"  #auto="matAutocomplete"  >
             <mat-option *ngFor="let model of modelList" [value]="model.modelName" >
              {{model.modelName}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field> -->
   

        <mat-form-field  class="header-form-full-width">
          <input type="text"  [(ngModel)]="InputSelectmodel"  placeholder="{{'Select Build #' | translate | async}}"  (input)="changeModelAutoComplete($event)"   matInput  [matAutocomplete]="auto" ngDefaultControl>
          <mat-autocomplete (optionSelected)="onSelectBuildNO($event.option.value)"   [(ngModel)]="Selectmodel" #model_auto="ngModel"  #auto="matAutocomplete"   ngDefaultControl  >
             <mat-option *ngFor="let model of modelList" [value]="model.modelName" >
              {{model.modelName}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

           
        <mat-form-field class="header-form-full-width">
          <mat-label>{{'Enter Serial # Start' | translate | async}}</mat-label>
          <input  type="text" matInput placeholder="{{'Enter Serial # Start' | translate | async}}" [(ngModel)]="serialStart"
           >
        </mat-form-field>

       
        <mat-form-field class="header-form-full-width">
          <mat-label>{{'Enter Serial # End' | translate | async}}</mat-label>
          <input  type="text" matInput placeholder="{{'Enter Serial # End' | translate | async}}" [(ngModel)]="serialEnd"
           >
        </mat-form-field>

     

        
        <mat-form-field class="header-form-full-width">
          <mat-select 
            placeholder="{{'Select Doc. Type' | translate | async}}" [(ngModel)]="docTypeID">
            <mat-option [value]="type.ID" *ngFor="let type of docTypeList">{{type.DocType}}</mat-option>    
          </mat-select>
        </mat-form-field>

<!-- 
        <mat-form-field class="header-form-full-width">
          <mat-label>Enter Doc. Heading</mat-label>
          <input  type="text" matInput placeholder="Enter Doc. Heading" [(ngModel)]="docHeading"
           >
        </mat-form-field> -->
        

        <!-- <mat-form-field class="header-form-full-width invisible"  >
          <mat-select name="customer" class="invisible" >
        </mat-select>
        </mat-form-field> -->

        <!-- <mat-form-field class="header-form-full-width">
          <mat-label>Enter Doc. #</mat-label>
          <input  type="text" matInput placeholder="Enter Doc. #" [(ngModel)]="docNumber"
           >
        </mat-form-field>


        <mat-form-field class="header-form-full-width">
          <mat-label>Enter Doc. Rev#</mat-label>
          <input  type="text" matInput placeholder="Enter Doc. Rev#" [(ngModel)]="docRev"
           >
        </mat-form-field> -->
      
       

        <mat-form-field class="header-form-full-width">
          <mat-select 
            placeholder="{{'Select Doc. Status' | translate | async}}" [(ngModel)]="docStatus">
            <mat-option [value]="1">{{'Active' | translate | async}}</mat-option>
            <mat-option [value]="2">{{'Expired' | translate | async}}</mat-option>
          </mat-select>
        </mat-form-field>
        
        <mat-form-field class="header-form-full-width invisible">
          <mat-select name="customer" class="invisible">
          </mat-select>
        </mat-form-field> 
        
        <mat-form-field class="header-form-full-width">        
          <input matInput [matDatepicker]="pickerStart" [(ngModel)]="startDate" >
          <mat-placeholder >{{'Select Start Date' | translate | async}}</mat-placeholder>
          <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle>
          <mat-datepicker #pickerStart></mat-datepicker>
        </mat-form-field>

        
        <mat-form-field class="header-form-full-width">        
          <input matInput [matDatepicker]="pickerEnd" [(ngModel)]="endDate" >
          <mat-placeholder >{{'Select End Date' | translate | async}}</mat-placeholder>
          <mat-datepicker-toggle matSuffix [for]="pickerEnd"></mat-datepicker-toggle>
          <mat-datepicker #pickerEnd></mat-datepicker>
        </mat-form-field>

 
     

      

        <mat-form-field class="header-form-full-width invisible"  >
          <mat-select name="customer" class="invisible" >
        </mat-select>
        </mat-form-field>


  


       
        <div style="min-width: 30%;width: 30%;"></div>



        <div style="display: flex;flex-direction: row;justify-content: flex-end;align-self: flex-end;">
        
          <button style="margin-left: 20px;" class="button button--primary" (click)="RestFields()" ><span
              class="button__text">{{'Reset' | translate | async}}</span></button>
              <button style="margin-left: 20px;" class="button button--primary" (click)="SeachDocs()"><span
                class="button__text">{{'Search' | translate | async}}</span></button>
        </div>

      </div>

    </mat-card>


    <div style="width: 100%;">
     
      
      <table class="table table--full-width table--striped" style="margin-top: 9px;">
        
        <thead>
          <tr>
            <th style="display: flex;flex-direction: row;justify-content: space-between;">
              <div style="display: flex;flex: 1;justify-content: center;">
                <span
                  style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{'Model' | translate | async}}</span>

              </div>
              <div style="display: flex;flex: 1;justify-content: center;">
                <span
                  style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{'SN# Start' | translate | async}}</span>
              </div>
              <div style="display: flex;flex: 1;justify-content: center;">
                <span
                  style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{'SN# End' | translate | async}}</span>
              </div>
              <div style="display: flex;flex: 1;justify-content: center;">
                <span
                  style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{'Doc. Type' | translate | async}}
                  </span>
              </div>
              <!-- <div style="display: flex;flex: 1;justify-content: center;">
                <span
                  style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">Doc. Heading
                  </span>
              </div> -->
              <!-- <div style="display: flex;flex: 1;justify-content: center;">
                <span
                  style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">Doc. #
                  </span>
              </div> -->
              <!-- <div style="display: flex;flex: 1;justify-content: center;">
                <span
                  style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">Rev. #</span>
              </div> -->
              <div style="display: flex;flex: 1;justify-content: center;">
                <span
                  style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{'Status' | translate | async}}</span>
              </div>
              <div style="display: flex;flex: 1;justify-content: center;">
                <span
                  style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{'Start Date' | translate | async}}</span>
              </div>
              <div style="display: flex;flex: 1;justify-content: center;">
                <span
                  style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{'End Date' | translate | async}}</span>
              </div>
            

            </th>
          </tr>
        </thead>
         <tbody>
          <tr *ngFor="let sr of SearchResultsList">
            <td style="min-width: 50px;display: flex;flex-direction: row;justify-content: space-between;">

              <div style="display: flex;flex: 1;justify-content: center;">
                <span  (click)="onClickOpenForm(sr)" class="SerialAndUnitText"
                  style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{sr.ModelNames}}</span>
              </div>
              <div style="display: flex;flex: 1;justify-content: center;">
                <span (click)="onClickOpenForm(sr)"
                  style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{sr.SerialStart}}</span>
              </div>
              <div style="display: flex;flex: 1;justify-content: center;">
                <span (click)="onClickOpenForm(sr)"
                  style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{sr.SerialEnd}}</span>
              </div>
              <div style="display: flex;flex: 1;justify-content: center;">
                <span (click)="onClickOpenForm(sr)"
                  style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{sr.DocTypeName}}</span>
              </div>
              <!-- <div style="display: flex;flex: 1;justify-content: center;">
                <span (click)="onClickOpenForm(sr)"
                  style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{sr.DocHeading}}</span>
              </div> -->
              <!-- <div style="display: flex;flex: 1;justify-content: center;">
                <span (click)="onClickOpenForm(sr)"
                  style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{sr.DocNo}}</span>
              </div>
              <div style="display: flex;flex: 1;justify-content: center;">
                <span (click)="onClickOpenForm(sr)"
                  style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{sr.DocRevNo}}</span>
              </div> -->
              <div style="display: flex;flex: 1;justify-content: center;">
                <span (click)="onClickOpenForm(sr)"
                  style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{sr.DocStatusName}}</span>
              </div>
              <div style="display: flex;flex: 1;justify-content: center;">
                <span (click)="onClickOpenForm(sr)"
                  style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{sr.StartDate | date:'dd MMM yyyy'}}</span>
              </div>
              <div style="display: flex;flex: 1;justify-content: center;">
                <span (click)="onClickOpenForm(sr)"
                  style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{sr.EndDate | date:'dd MMM yyyy'}}</span>
              </div>
            </td>
          </tr>
        </tbody> 
      </table>

      <!-- <div style="display: flex;flex-direction: column;align-items: center;
  justify-content: center;min-height: 500px;align-self: center;">
        <mat-spinner></mat-spinner>
      </div> -->

    </div>

  

</div>